import React from "react";
import { useStores } from "@ms/uno-controls/lib/local/hooks/useStores";
import { LazyLoopResponseSection } from "./LazyLoopResponseSection";
import { Store } from "@ms/uno-stores/lib/local/stores/Store";
/**
 * The LoopResponseSectionContainer component
 * @param props - The props for the component
 */ export const LoopResponseSectionContainer = ({ fetchAccessTokenCallback, taskId })=>{
    const [basicTaskStore, basicPermissionsStore, basicPlanStore] = useStores([
        Store.BasicTask,
        Store.BasicPermissions,
        Store.BasicPlan
    ]);
    const task = basicTaskStore?.getTask(taskId).data;
    const planId = task?.planId;
    const plan = planId ? basicPlanStore?.getPlan(planId).data : null;
    const loopPageUrl = basicTaskStore?.getTask(taskId).data?.internalProperties.copilot?.loopPageUrl;
    if (!(loopPageUrl && plan && basicPermissionsStore?.getPlanPermissions(plan)?.canUseAgents)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(LazyLoopResponseSection, {
        fetchAccessTokenCallback: fetchAccessTokenCallback,
        loopPageUrl: loopPageUrl,
        taskId: taskId
    });
};
